import React from 'react';
import PropTypes from 'prop-types';
import { Form, Alert, Button } from 'react-bootstrap';

const ServerRequest = require('../../actions/request');
import WarningBox from '../common/WarningBox';

const propTypes = {
    user: PropTypes.object.isRequired
};

const defaultProps = {};

class AdminUserPartnerKeyEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            canEditPartnerKey: false,
            canEditPartnerSecret: false,
            userPartnerKeyChanged: false,
            userPartnerSecretChanged: false,
            userPartnerKey: props.user.key === null ? '' : props.user.key,
            userPartnerSecret: props.user.secret === null ? '' : props.user.secret,
            partnerCredMessageVisible: false,
            partnerCredMessageState: '',
            partnerCredMessage: ''
        };

        this.updateCanEditPartnerKey = this.updateCanEditPartnerKey.bind(this);
        this.updateCanEditPartnerSecret = this.updateCanEditPartnerSecret.bind(this);
        this.partnerKeyChange = this.partnerKeyChange.bind(this);
        this.partnerSecretChange = this.partnerSecretChange.bind(this);
        this.updatePartnerCredentials = this.updatePartnerCredentials.bind(this);
        this.deletePartnerCredentials = this.deletePartnerCredentials.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.id === this.props.user.id) {
            return;
        }

        this.setState({ // eslint-disable-line  @eslint-react/no-set-state-in-component-did-update
            canEditPartnerKey: false,
            canEditPartnerSecret: false,
            userPartnerKeyChanged: false,
            userPartnerSecretChanged: false,
            userPartnerKey: this.props.user.key === null ? '' : this.props.user.key,
            userPartnerSecret: this.props.user.secret === null ? '' : this.props.user.secret,
            partnerCredMessageVisible: false,
            partnerCredMessageState: '',
            partnerCredMessage: ''
        });
    }

    updateCanEditPartnerKey(e){
        this.setState({ canEditPartnerKey: !this.state.canEditPartnerKey })
    }

    updateCanEditPartnerSecret(e){
        this.setState({ canEditPartnerSecret: !this.state.canEditPartnerSecret })
    }

    partnerKeyChange(e){
        // console.log(e.target.value, this.state.userPartnerKey, e.target.value !== '' && e.target.value !== '')
        this.setState({
            userPartnerKey: e.target.value,
            userPartnerKeyChanged: e.target.value !== this.state.userPartnerKey && e.target.value !== ''
        });

    }

    partnerSecretChange(e){
        // console.log(e.target.value, this.state.userPartnerSecret, e.target.value !== '' && e.target.value !== '')
        this.setState({
            userPartnerSecret: e.target.value,
            userPartnerSecretChanged: e.target.value !== this.state.userPartnerSecret && e.target.value !== ''
        });
    }

    updatePartnerCredentials(e){
        const self = this;
        if (confirm("Are you sure you want to update the user's key & secret?")) {
            ServerRequest.makeRequest(('/authoring/user/' + this.props.user.id + '/update/partner_credentials'), 'POST', JSON.stringify({key: this.state.userPartnerKey, secret: this.state.userPartnerSecret}))
            .then(function(res) {
                self.setState({ partnerCredMessageVisible:true, partnerCredMessageState: 'success' , partnerCredMessage: 'Credentials Updated'});
            })
            .catch(function(err) {
                console.log("error", err)
                self.setState({ partnerCredMessageVisible:true, partnerCredMessageState: 'danger' , partnerCredMessage: 'There was a problem updating Credentials'});
            });
        }
    }

    deletePartnerCredentials(e){
        const self = this;
        if (confirm("Are you sure you want to delete the users credentials?")) {
            ServerRequest.makeRequest(('/authoring/user/' + this.props.user.id + '/delete/partner_credentials'), 'POST')
            .then(function(res) {
                console.log("updated")
                self.setState({ userPartnerKey: '', userPartnerSecret: '' });
            })
            .catch(function(err) {console.log("error", err)});
        }
    }

    render() {
        return (
            <div>
                {(!!this.props.user.partner_name) && <div>Associated Partner: {this.props.user.partner_name}</div>}
                { (!this.props.user.third_party_id) &&
                    <Form>
                        <Form.Group controlId="admin-users-partner-key">
                            <Form.Label>Partner Key</Form.Label>
                            <Form.Control
                                className="min-width-guid"
                                aria-label="Partner Key"
                                value={this.state.userPartnerKey}
                                onChange={this.partnerKeyChange}
                                disabled={!this.state.canEditPartnerKey}
                            />
                        </Form.Group>

                        <Button onClick={this.updateCanEditPartnerKey}>
                            <i className={!this.state.canEditPartnerKey ? 'fa fa-lock' : 'fa fa-unlock-alt'} aria-hidden="true" />
                        </Button>
                    </Form>
                }
                {(!this.props.user.third_party_id) &&
                    <Form>
                        <Form.Group controlId="admin-users-partner-secret">
                            <Form.Label>Partner Secret</Form.Label>
                            <Form.Control
                                size="lg"
                                value={this.state.userPartnerSecret}
                                onChange={this.partnerSecretChange}
                                disabled={!this.state.canEditPartnerSecret}
                            />
                        </Form.Group>

                        <Button onClick={this.updateCanEditPartnerSecret}>
                            <i className={!this.state.canEditPartnerSecret ? 'fa fa-lock' : 'fa fa-unlock-alt'} aria-hidden="true" />
                        </Button>

                        <Button onClick={this.updatePartnerCredentials} disabled={!(this.state.userPartnerKeyChanged && this.state.userPartnerSecretChanged)}>
                            Update
                        </Button>

                        <Button onClick={this.deletePartnerCredentials}>
                            Delete
                        </Button>
                    </Form>
                }
                {(this.state.partnerCredMessageVisible) &&
                    <Alert variant={this.state.partnerCredMessageState}>
                        <h4>{this.state.partnerCredMessage}</h4>
                    </Alert>
                }
                {(this.state.userPartnerKey || this.state.userPartnerSecret) &&
                    <WarningBox>Updating partner credentials will make old assignments permanently inaccessible!</WarningBox>
                }
            </div>
        );
    }
}

AdminUserPartnerKeyEditor.propTypes = propTypes;
AdminUserPartnerKeyEditor.defaultProps = defaultProps;

export default AdminUserPartnerKeyEditor;